import React from "react";


export function CustomLoader() {
    return <div className="d-flex justify-content-center mt-5">
        Loading...
    </div>

}
